export const ALERT_POPUP_TYPE = 'AlertPopup';
export const CONFIRM_POPUP_TYPE = 'ConfirmPopup';
export const exitPage = () => {
  if (window.Android) {
    window.Android.exit();
  }
};
